import React, {useCallback, useMemo, useState} from "react";
import {Control, UseFormGetValues, UseFormRegister, UseFormSetValue} from "react-hook-form";
import SearchProductInner from "../../../../../components/common/modal/inner/SearchProductInner";
import {useModal} from "../../../../../hooks";
import EmptyTableRow from "../../../../common/EmptyTableRow";
import {OrdersCreateSubjectType} from "../interface";
import {ordersCreateSubjectElementInit} from "../state";
import {useReadCurrencyTypeSelectBox} from "../hooks/useReadCurrencyTypeSelectBox";
import DisplayNumber from "../../../../../components/common/number/DisplayNumber";
import InputNumberUc from "../../../../../components/common/number/InputNumberUc";

interface PropsType {
    watchCreateSubject: OrdersCreateSubjectType
    register: UseFormRegister<OrdersCreateSubjectType>
    getValues: UseFormGetValues<OrdersCreateSubjectType>
    setValue: UseFormSetValue<OrdersCreateSubjectType>
    control: Control<OrdersCreateSubjectType>
}

export default function Tab2({watchCreateSubject, getValues, setValue, register, control}: PropsType) {
    const {handleModal} = useModal();

    const [checkedIdx, setCheckedIdx] = useState<number[]>([])

    const {data: currencyList} = useReadCurrencyTypeSelectBox()

    const isAllCheck = watchCreateSubject.list.length !== 0
        && watchCreateSubject.list.every((el, idx) => checkedIdx.includes(idx))

    const clickCheck = (idx: number) => {
        if (checkedIdx.includes(idx)) {
            setCheckedIdx(checkedIdx.filter(el => el !== idx))
        } else {
            setCheckedIdx([...checkedIdx, idx])
        }
    }

    const clickAllCheck = () => {
        if (!isAllCheck) {
            setCheckedIdx(Array.from({length: watchCreateSubject.list.length}, (_, i) => i))
        } else {
            setCheckedIdx([])
        }
    }

    const btnAdd = () => {
        const list = [...getValues("list"), ordersCreateSubjectElementInit]

        setValue("list", list)
    }

    const btnDelete = () => {
        const list = getValues("list").filter((_, idx) => !checkedIdx.includes(idx))

        setValue("list", list)
    }


    const btnSearchProduct = useCallback((idx: number) => {
        handleModal({
            isOpen: true,
            contents: <SearchProductInner
                confirmCallback={(item) => {
                    const product = item.productDetailRes

                    const list = getValues("list").map((el, idx2) => {
                        if (idx === idx2) {
                            return {
                                ...el,
                                _new_l_erp_product_value: product.newErpProductid,
                                newTxtNmItem: product.newTxtNmItem,
                                new_txt_standard: product.newTxtStndItem,
                                _new_l_product_group_value: product.newLProductGroupValue,
                                productGroupName: product.productRange
                            }
                        } else {
                            return el
                        }
                    })

                    setValue("list", list)
                }}
                modalDepth={1}
            />,
            type: "",
            title: "제품 조회",
            modalSize: "xxl"
        })
    }, [])

    const currencyOptions = useMemo(() => {
        return currencyList ? currencyList.map((el: any) => <option value={el.id}>{el.name}</option>) : <></>
    }, [currencyList])

    return <div className="content_wrap">
        <div className="table_top">
            <h6 className="table_stats">수주 품목</h6>
            <div className="table_toolbar">
                <button className="btn btn-dark w-80px" onClick={btnAdd}>추가</button>
                <button className="btn btn-outline-dark w-100px px-0" onClick={btnDelete}>
                    <img src={process.env.PUBLIC_URL + "/assets/images/icon_cross.png"} alt=""/>
                    선택삭제
                </button>
            </div>
        </div>
        <div className="table_scroll mb-0">
            <table className="table table-bordered my_table table_detail">
                <thead>
                <tr>
                    <th style={{width: "3%"}}>
                        <div className="checkbox_outer">
                            <input
                                className="form-check-input"
                                type="checkbox"
                                checked={isAllCheck}
                                onClick={clickAllCheck}
                            />
                        </div>
                    </th>
                    <th style={{width: "12%"}}>제품군</th>
                    <th style={{width: "24%"}}>품목</th>
                    <th style={{width: "14%"}}>규격</th>
                    <th style={{width: "9%"}}>환종</th>
                    <th style={{width: "9%"}}>환율</th>
                    <th style={{width: "9%"}}>단가</th>
                    <th style={{width: "9%"}}>수량</th>
                    <th style={{width: "11%"}}>금액</th>
                </tr>
                </thead>
                <tbody>
                {watchCreateSubject.list.length !== 0
                    ? watchCreateSubject.list.map((el, idx) =>
                        <tr>
                            <td>
                                <div className="checkbox_outer">
                                    <input
                                        className="form-check-input"
                                        type="checkbox"
                                        checked={checkedIdx.includes(idx)}
                                        onClick={() => clickCheck(idx)}
                                    />
                                </div>
                            </td>
                            <td className="p-4px">
                                <input type="text" className="form-control"
                                       value={el.productGroupName}
                                       disabled/>
                            </td>
                            <td className="p-4px">
                                <div className="d-flex">
                                    <input type="text" className="form-control"
                                           value={el.newTxtNmItem}
                                           disabled/>
                                    <button
                                        className="btn btn-info btn_search w-100px ms-5px"
                                        onClick={() => btnSearchProduct(idx)}>
                                        <img
                                            src={process.env.PUBLIC_URL + "/assets/images/icon_search.png"}
                                            alt=""
                                        />찾기
                                    </button>
                                </div>
                            </td>
                            <td className="p-4px">
                                <input type="text" className="form-control"
                                       value={el.new_txt_standard}
                                       disabled/>
                            </td>
                            <td className="p-4px text-center">
                                <select className="form-select"
                                        value={el.new_p_currency}
                                        {...register(`list.${idx}.new_p_currency`)}
                                        onChange={e => {
                                            const value = e.target.value

                                            setValue(`list.${idx}.new_p_currency`, value)
                                            value === "100000000" && setValue(`list.${idx}.new_d_exchange_rate`, 1);
                                        }}
                                >
                                    <option value={""}>선택</option>
                                    {currencyOptions}
                                </select>
                            </td>
                            <td className="p-4px">
                                <InputNumberUc control={control} name={`list.${idx}.new_d_exchange_rate`}
                                               disabled={getValues(`list.${idx}.new_p_currency`) == "100000000"}/>
                                {/*<input type="text" className="form-control text-end"
                                       value={el.new_d_exchange_rate}
                                       {...register(`list.${idx}.new_d_exchange_rate`)}
                                       disabled={getValues(`list.${idx}.new_p_currency`) == "100000000"}
                                />*/}
                            </td>
                            <td className="p-4px">
                                <InputNumberUc control={control} name={`list.${idx}.new_d_unitprice`}/>
                                {/*<input type="text" className="form-control text-end"
                                       value={el.new_d_unitprice}
                                       {...register(`list.${idx}.new_d_unitprice`)}/>*/}
                            </td>
                            <td className="p-4px">
                                <InputNumberUc control={control} name={`list.${idx}.new_i_qty`}/>
                                {/*<input type="text" className="form-control text-end"
                                       value={el.new_i_qty}
                                       {...register(`list.${idx}.new_i_qty`)}
                                />*/}
                            </td>
                            <td className="text-end"><DisplayNumber value={el.new_i_qty * el.new_d_unitprice}/></td>
                        </tr>
                    )
                    : <EmptyTableRow colSpan={9} msg={`수주 품목을 추가해주세요.`}/>
                }
                </tbody>
                <tfoot>
                <tr>
                    <td className="text-start grey" colSpan={7}></td>
                    <td className="text-end">
                        {isNaN(watchCreateSubject.list.reduce((acc, cur) => acc + Number(cur.new_i_qty), 0))
                            ? <>-</>
                            : <DisplayNumber
                                value={watchCreateSubject.list.reduce((acc, cur) => acc + Number(cur.new_i_qty), 0)}/>
                        }
                    </td>
                    <td className="text-end">{isNaN(watchCreateSubject.list.reduce((acc, cur) => acc + Number(cur.new_i_qty * cur.new_d_unitprice), 0))
                        ? <>-</>
                        : <DisplayNumber
                            value={watchCreateSubject.list.reduce((acc, cur) => acc + Number(cur.new_i_qty * cur.new_d_unitprice), 0)}/>
                    }</td>
                </tr>
                </tfoot>
            </table>
        </div>
    </div>
}